const getFullDate = (date: string | null = null): string => {
  const originalDate = date ? new Date(date) : new Date();
  return originalDate.toLocaleString('en-US', { dateStyle: 'full' });
};

export default getFullDate;
